// Port de app/biometric-setup.tsx.
import { Carregando } from "@/app/Carregando";
import { lazy } from "react";

const BiometricSetupScreen = lazy(() => import("@/screens/BiometricSetup"));

export default function BiometricSetupRoute() {
  return (
    <Carregando cor="#294956">
      <BiometricSetupScreen />
    </Carregando>
  );
}
